<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-down`]" width="1em" height="1em" v-bind="$attrs"><path d="M14.0864 13.1348C14.4535 13.135 14.7514 13.4327 14.7515 13.7998C14.7515 14.167 14.4535 14.4646 14.0864 14.4648H1.91357C1.5463 14.4648 1.24854 14.1671 1.24854 13.7998C1.24864 13.4326 1.54637 13.1348 1.91357 13.1348H14.0864ZM8.00049 1.22852C8.36848 1.22859 8.66727 1.52755 8.66748 1.89551V9.58398L11.689 6.5625C11.9493 6.30261 12.3711 6.30336 12.6313 6.56348C12.891 6.82373 12.8911 7.24469 12.6313 7.50488L9.22607 10.9111C9.10195 11.0353 8.98016 11.1572 8.86963 11.251C8.75319 11.3498 8.60536 11.4559 8.4126 11.5186C8.14495 11.6055 7.85605 11.6064 7.58838 11.5195C7.3954 11.4568 7.24689 11.3499 7.13037 11.251C7.01989 11.1572 6.89799 11.0352 6.77393 10.9111L3.36865 7.50586C3.10866 7.24557 3.10861 6.82276 3.36865 6.5625C3.6289 6.30227 4.05163 6.30249 4.31201 6.5625L7.3335 9.58398V1.89551C7.33371 1.52752 7.63247 1.22856 8.00049 1.22852Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineDown',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
